import {breakpoints} from '@/theme/lib';

export enum WindowWidth {
  Mobile = Number(breakpoints.md),
  Tablet = Number(breakpoints.lg),
}
